import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const NotFound = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">404 Error</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">404 - Not Found</li>
                            <li className="breadcrumb-item active" aria-current="page">404 Error</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* 404 Start */}
            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <i className="bi bi-exclamation-triangle display-1 text-primary"></i>
                            <h1 className="display-1">404</h1>
                            <h1 className="mb-4">Page Not Found</h1>
                            <p className="mb-4">We’re sorry, the page you have looked for does not exist in our website! Maybe go to
                                our home page or try to use a search?</p>
                            <a className="btn btn-primary py-3 px-5" href="/">Go Back To Home</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* 404 End */}

            <Footer />
        </>
    );
};

export default NotFound;
